module.exports = __webpack_public_path__ + "static/media/downloadCloud.12f5ca92.svg";